import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, sizes } from '@/utils'

import render from './render'

const defaultButtonProps = {
  mode: buttonModes.flat,
  color: Colors.white,
  size: sizes.small
}

export default {
  name: components.snackbar,

  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    closeButtonProps() {
      if (this.viewport.breakpoint.smDown) {
        return {
          ...defaultButtonProps,
          label: this.getTranslate('misc.buttons.close')
        }
      }

      return {
        ...defaultButtonProps,
        icon: icons.clear
      }
    },

    transitionGroupProps() {
      let modifier = ''
      if (this.viewport.breakpoint.smDown) {
        modifier = '--mobile'
      }

      return {
        tag: 'div',
        name: `${components.snackbar}-fade${modifier}`,
        css: true,
        appear: true
      }
    }
  },

  methods: {
    getItemButtonProps(item) {
      return {
        ...defaultButtonProps,
        ...item.button.props
      }
    }
  },

  render
}
